import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

interface ParkingLot {
  name: string;
  totalSpaces: number;
}

@Component({
    selector: 'app-space-allocation-modal',
    templateUrl: './space-allocation-modal.component.html',
    styleUrls: ['./space-allocation-modal.component.scss'],
    imports: [
    ReactiveFormsModule
]
})
export class SpaceAllocationModalComponent extends SimpleModalComponent<{ parkingLots: ParkingLot[] }, ParkingLot[]> {
  @Input() parkingLots: ParkingLot[] = [];

  originalTotal: number = 0;
  originalAllocations: number[] = [];

  ngOnInit() {
    // Store the original total and individual allocations
    this.originalTotal = this.parkingLots.reduce((sum, lot) => sum + lot.totalSpaces, 0);
    this.originalAllocations = this.parkingLots.map(lot => lot.totalSpaces);
  }

  onSpaceAllocationChange(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = parseInt(input.value);
    
    // Calculate the other lot's index
    const otherLotIndex = index === 0 ? 1 : 0;
    
    // Calculate how much this lot has changed from its original allocation
    const change = value - this.originalAllocations[index];
    
    // Adjust the other lot's spaces by the opposite of the change
    const otherLotNewSpaces = this.originalAllocations[otherLotIndex] - change;
    
    // Update both lots' spaces
    this.parkingLots[index].totalSpaces = value;
    this.parkingLots[otherLotIndex].totalSpaces = otherLotNewSpaces;
  }

  onNumberInputChange(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    let value = parseInt(input.value);
    
    // Ensure the value is a valid number
    if (isNaN(value)) {
      value = 0;
    }
    
    // Ensure the value is not negative
    if (value < 0) {
      value = 0;
    }
    
    // Calculate the other lot's index
    const otherLotIndex = index === 0 ? 1 : 0;
    
    // Calculate how much this lot has changed from its original allocation
    const change = value - this.originalAllocations[index];
    
    // Adjust the other lot's spaces by the opposite of the change
    const otherLotNewSpaces = this.originalAllocations[otherLotIndex] - change;
    
    // Update both lots' spaces
    this.parkingLots[index].totalSpaces = value;
    this.parkingLots[otherLotIndex].totalSpaces = otherLotNewSpaces;
  }

  onSave(): void {
    this.result = this.parkingLots;
    this.close();
  }

  onClose(): void {
    this.close();
  }
} 
